<template>
<div class="container front-paga">
    <header >
    <SidebarFront></SidebarFront>   
    <nav class="header-navbar navbar navbar-with-menu ">
      <div class="navbar-wrapper container">
        <div class="navbar-header mr-3">
          <ul class="nav navbar-nav">
              <li class="nav-item  " @click="$store.state.sidebarOpened = !$store.state.sidebarOpened">
                <a class="nav-link  hidden-sm-up">
                    <i class="icon-menu5 pr-2"></i>
                </a>
              </li>
              <li class="nav-item">
                <a class="navbar-brand nav-link">               
                    <div id="logo" class="brand-logo"></div>
                </a>
              </li>            
          </ul>
        </div>
        <div class="navbar-container content container-fluid">
          <div id="navbar-mobile" class=" navbar-toggleable-sm">
            <ul class="nav navbar-nav" v-scroll-spy-active="{class: 'custom-active'}" v-scroll-spy-link>              
              <li class="nav-item dropdown login-link mr-1 menu-link hidden-sm-down">               
                <a class="nav-link" v-scroll-to="'#tenders'" >{{ $t('pages.tenders')}}</a>                
              </li>
              <li class="nav-item dropdown login-link mr-1 menu-link hidden-sm-down">   
                <a class="nav-link" v-scroll-to="'#about'">{{ $t('pages.about')}}</a>              
              </li>
              <li class="nav-item dropdown  login-link menu-link hidden-sm-down">
                <a class="nav-link" v-scroll-to="'#contact'" >{{ $t('pages.contacts')}}</a> 
              </li>
            </ul>
            <ul class="nav navbar-nav float-xs-right">
                <li class="dropdown nav-item login-link register-link">
                  <a class="btn" href="/register">{{ $t('login.lbl.register')}}</a>
                </li>
                <li class="dropdown nav-item login-link register-link">
                  <a class="btn" href="/login">{{ $t('login.btn.login')}}</a>
                </li>
               
              <li class="dropdown dropdown-language nav-item">
                <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle nav-link">
                  <!-- <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i> -->
                  <span class="selected-language"> {{$i18n.tc('lang.titleS', $i18n.locale )}}</span>
                </a>                
                <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                  <a class="dropdown-item" @click="changeLanguage('ua')">UA </a>
                  <a class="dropdown-item" @click="changeLanguage('pl')">Pl</a>
                  <a class="dropdown-item" @click="changeLanguage('en')">EN </a>                  
                  <a class="dropdown-item" @click="changeLanguage('ru')">RU</a>                  
                </div>
              </li>                   
            </ul>
          </div>
        </div>
      </div>
        </nav>
    </header>
    <div class="container main-wraper">
        <main>
            <section v-if="content">
                <article v-html="content.top.text">
                    <!-- <p>This is the tender portal of Modern Expo. </p>
                    <p>Here you can take part in tenders for transport services, purchase of goods and services, purchase of installation services.</p> -->
                </article>
            </section>
             <section class="tender-type-swicher mt-3" id="tenders">
                 <div class="">
                     <div class="row">
                         <div class="col-md-12">
                             <div class="title">
                                 <h1>{{ $t('pages.tenders')}}</h1>
                             </div>                             
                         </div>
                          <div class="col-md-12">
                              <div id="heading41" class="tender-type-item">
                                <a data-toggle="collapse" data-parent="#accordionWrap4" href="#accordion41" aria-expanded="true" aria-controls="accordion41" class="card-title lead tender-type-link"> {{ $t('mail.transport-services')}}</a>
                            </div>
                            <div id="accordion41" role="tabpanel" aria-labelledby="heading41" class="card-collapse  " aria-expanded="true" style="">
                                <div class="card-content">
                                    <div class="card-body">
                                        <div class="card-block p-0" > 

                                         <!-- <div class="container-fluid mb-2">
                                            <div class="row" style="padding-left:20px">
                                                <div class="col-md-12">
                                                    <fieldset class="position-relative">
                                                        <input type="text" class="form-control form-control input" placeholder="" v-model="filterStr" >
                                                        <div class="form-control-position" style="top:5px; right:10px;">
                                                            <i class="icon-search4 font-medium-4"></i>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>    -->
                                        <!-- filter by stutus -->                        
                                        <!-- <div class="row statuses-container">                                
                                            <div class="col-md-12" style="justify-content: center !important;">
                                                <div v-for="(st, index) in clientFilet" :key="index" class="badge hand custom_filter" :class="$t('tender.statuses.' + st.id + '.class')"  @click="filtrClick(st)" style="margin-left: 1%; margin-bottom: 1%;">
                                                    <i :class="[st.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i>
                                                    <span style="bagraund-color:#000">{{ $t('tender.statuses.' + st.id + '.title') }}</span>
                                                </div>                                   
                                                <div v-for="(stat, sindex) in tender.deliveryStatus" :key="sindex+10" class="badge hand custom_filter" :class="$t('tender.deliveryStatus.' + stat.id + '.class')"  @click="filterBydeliveryClick(stat)" style="margin-left: 1%; margin-bottom: 1%;">
                                                    <i :class="[stat.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i>
                                                    <span style="bagraund-color:#000">{{ $t('tender.deliveryStatus.' + stat.id + '.title') }}</span>
                                                </div>
                                            </div>
                                        </div> -->

                                        <!-- ______________________________________main-tables    -->
                                        <div class="main-tables mobileTbl table-responsive ">
                                                <table class="table table-hover mb-0 loading" cellspacing="0" >
                                                    <thead>
                                                        <tr> 
                                                            <!-- <th style="vertical-align: middle;"></th>     -->
                                                            <th style="vertical-align: middle;">{{ $t('tender.table.number') }}</th>                                                           
                                                            <th style="vertical-align: middle;">{{ $t('tender.table.closeDay') }}</th>                                                           
                                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>
                                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadDate') }}</th>                                                                                                         
                                                            <th style="vertical-align: middle;">{{ $t('tender.table.productWeight') }}</th>
                                                            <th style="vertical-align: middle;">{{ $t('tender.table.typeOfCar') }}</th>
                                                            <th style="vertical-align: middle;">{{ $t('tender.table.deliveryAdress') }}</th>                                         
                                                                                
                                                        </tr>
                                                    </thead>                                                       
                                                    <tbody>                              
                                                        <tr class="marginTR" v-for="(item,index) in paginatedData" :key="index">
                                                            <!-- <td ></td>  -->
                                                            <td :data-title="$t('tender.table.numberStatus')">  
                                                                <!-- <span class="badge" :class="$t('tender.statuses.' + item.status + '.class')">{{$t('tender.statuses.' + item.status + '.title')}}</span> <br> -->
                                                                {{item.number}}<br>
                                                                
                                                            
                                                            </td>

                                                            <td :data-title="$t('tender.table.closeDay')"> {{item.closeDate}}</td>                                            
                                                            <td :data-title="$t('tender.table.downloadAdress')"> {{item.loadingAdress}}</td>                                            
                                                            <td  :data-title="$t('tender.table.date')">{{item.loadingDate}}</td>
                                                            <td  :data-title="$t('tender.table.productWeight')">{{item.weight}}</td>
                                                            <td  :data-title="$t('tender.table.typeOfCar')">{{item.bodyVolume}}</td>
                                                            <td  :data-title="$t('tender.table.deliveryAdress')"> {{item.deliveryAdress}}</td>
                                                        
                                                        </tr>   
                                                    </tbody>
                                                </table>

                                        </div>
                                        <!-- ____________________and main tables -->                        
                                    
                                    
                                        <div v-if="pageCount > 1" class="navigator" style="text-align: center;">                           
                                            <ul class="pagination">
                                                <li class="page-item" v-if="pageNumber > 0">
                                                    <a class="page-link" @click="pageNumber--" ><i class="icon-arrow-left2"></i></a>
                                                </li>
                                                
                                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                                </li>
                                                
                                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                                    <a class="page-link"  @click="pageNumber++"><i class="icon-arrow-right2"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div id="heading42" class="tender-type-item ">
                                    <a data-toggle="collapse" data-parent="#accordionWrap4" href="#accordion42" aria-expanded="false" aria-controls="accordion42" class="card-title lead  collapsed tender-type-link">{{ $t('mail.goods-and-services')}}</a>
                                </div>
                                <div id="accordion42" role="tabpanel" aria-labelledby="heading42" class="card-collapse collapse" aria-expanded="false">
                                    <div class="card-content">
                                        <div class="card-body">
                                           {{ $t('mail.goods-and-services')}}
                                        </div>
                                    </div>
                                </div>
                                <div id="heading43" class="tender-type-item ">
                                    <a data-toggle="collapse" data-parent="#accordionWrap4" href="#accordion43" aria-expanded="false" aria-controls="accordion43" class="card-title lead  collapsed tender-type-link">{{ $t('mail.installation-services')}}</a>
                                </div>
                                <div id="accordion43" role="tabpanel" aria-labelledby="heading43" class="card-collapse collapse" aria-expanded="false">
                                    <div class="card-content">
                                        <div class="card-body">
                                           {{ $t('mail.installation-services')}}
                                        </div>
                                    </div>
                                </div>                                
                          </div>
                     </div>
                 </div>
                
            </section>
             <section class="about-us mt-3" id="about">
                 <div class="">
                     <div class="row">
                         <div class="col-md-12">
                             <div class="title">
                                 <h1>{{ $t('pages.about')}}</h1>
                             </div>                             
                         </div>
                         <div class="col-md-12">
                             <div class="row" v-if="content">
                                 <div class="text px-3 my-3 col-md-6" v-html="content.about.text">
                                 <!-- <p>Modern Expo has been a top company in creation of modern retail for more than 20 years.</p>
                                 <p>We are convinced that modern retail is a phenomenon encompassing a multilevel system of obtaining goods with the ultimate consumer. Today, it's not just the physical store space, but also the solutions for E-commerce, warehouses, logistics and integrated supply chain.</p> 
                                <p>Modern Expo is 9 high-tech production units specializing in different types of equipment.  Our manufacture is one of the most powerful in the world, we provide mass replication in roll-outs and ensure meeting each of our products with European safety and quality standards (EN and FEM).</p> 
                                <p>Today we have become a platform bringing together leading professionals into powerful teams of R&D, IT, retail design, engineering, etc., working in synergy to create the perfect retail of the future by Modern Expo.</p> -->

                             </div>
                             <div class="sub col-md-6">
                                 <a href="http://modern-expo.eu/about-us" target="_blank" > modern-expo.eu/about-us</a>
                                 <div class="img-container">
                                     <img src="../assets/pictures/18.png" alt="">
                                 </div>
                             </div>
                             </div>
                         </div>
                         
                     </div>
                 </div>
                
            </section>
             <section class="about-us mt-3">
                 <div class="">
                     <div class="row">
                         <div class="col-md-12">
                             <div class="title">
                                 <h1>{{ $t('pages.questions')}}?</h1>
                             </div>                             
                         </div>
                         <div class="col-md-12">
                            <div class="form mt-3">
                                <div class="form-body">
                                    <div class="col-md-6">
                                        <div class="form-group" :class="{ 'form-group--error': $v.form.firstName.$error }">                                            
                                            <input type="text" id="firstName" class="form-control" :placeholder="$t('mail.name')" name="name" v-model.trim="$v.form.firstName.$model" >
                                            <label for="firstName">{{$t('errors.required')}}</label>
                                        </div>
                                        <div class="form-group" :class="{ 'form-group--error': $v.form.familyName.$error }" >                                            
                                            <input type="text" id="family-name" class="form-control" :placeholder="$t('mail.family-name')" name="family-name*" v-model.trim="$v.form.familyName.$model">
                                            <label for="family-name">{{$t('errors.required')}}</label>
                                        </div>
                                        <div class="form-group" :class="{ 'form-group--error': $v.form.email.$error }" >                                            
                                            <input type="email" id="email" class="form-control" :placeholder="$t('registr.lbl.email')" name="email" v-model.trim="$v.form.email.$model" >
                                            <label for="family-name">{{$t('errors.required')}}</label>
                                        </div>
                                        <div class="form-group">                                            
                                            <toggle-button v-model="form.notifyByPhone" color="#000000"/>
                                            <span class="toogleLabel">{{$t('mail.notifyByPhone')}}</span>
                                        </div>

                                        <div class="form-group" v-if="form.notifyByPhone">                                            
                                            <input type="phone" id="phone" v-mask="'(###) ##-##-###'" class="form-control" :placeholder="$t('mail.phone')" name="phone" v-model="form.phone">
                                            <label for="phone">{{$t('errors.required')}}</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group" :class="{ 'form-group--error': $v.form.type.$error }" >                                            
                                             <select id="type" v-model.trim="$v.form.type.$model" >
                                                <option  value="0" disabled selected>{{$t('mail.question-type')}}</option>
                                                <option  value="1">{{$t('mail.transport-services')}}</option>
                                                <option  value="2">{{$t('mail.goods-and-services')}}</option>
                                                <option  value="3">{{$t('mail.installation-services')}}</option>
                                            </select> 
                                                                                     
                                        </div>
                                        <div class="form-group" :class="{ 'form-group--error': $v.form.message.$error }" >                                            
                                             <textarea id="message" rows="11" class="form-control" name="message" :placeholder="$t('mail.message')" v-model.trim="$v.form.message.$model" ></textarea>                                            
                                        </div>
                                    </div>               		    
                                    
                                </div>
                               
                            </div>
                         </div> 
                          <div class="col-md-12">
                            <div class="send-mess-btn">
                                <div class="rcapcha " :class="!this.rKey && !this.rcapchaError ? 'cliar' : 'rcapcha-error'" >
                                    <vue-recaptcha ref="recaptcha"   @expired="onCaptchaExpired" @verify="verifyRecaptcha" sitekey="6LeF_YAfAAAAAClSUjqkIZAz09J2fEXvykFaZxah">                                     
                                    </vue-recaptcha>
                                </div> 
                                 <button  @click="sendMessage" class="btn btn-outline-success" style="float:right">{{$t('label.send')}}</button>
                            </div>
                           
                           
                        </div>                        
                     </div>
                 </div>
                
            </section>
             <section class="about-us mt-3" id="contact">
                 <div class="">
                     <div class="row">
                         <div class="col-md-12">
                             <div class="title d-flex justify-content-between">
                                 <h1>{{ $t('pages.contact')}}</h1>
                                 <div class="social d-flex">
                                     <a href="https://www.facebook.com/ModernExpo" target="_blank" class="social-link mx-1"><img src="../assets/pictures/fb.png" alt="fb" ></a>
                                     <a href="https://www.linkedin.com/company/modernexpo" class="social-link mx-1" target="_blank"><img src="../assets/pictures/link.png" alt="link" ></a>
                                     <a href="https://www.instagram.com/modern_expo/" class="social-link mx-1" target="_blank"><img src="../assets/pictures/inst.png" alt="inst" ></a>
                                     <a href="https://www.youtube.com/c/ModernExpoGroup" class="social-link mx-1" target="_blank"><img src="../assets/pictures/yout.png" alt="yout" ></a>
                                 </div>
                             </div>                             
                         </div>
                         <div class="col-md-12 px-3">
                            <div class="row contacts mt-1">
                                <div class="col-md-3">                                    
                                    <span>{{ $t('footer.c1')}}</span>                                    
                                    {{ $t('footer.c11')}}<br>
                                    +380 (0332) 78-95-00<br>
                                    info@modern-expo.com<br>
                                </div>
                                <div class="col-md-3">
                                    <span>{{ $t('footer.c2')}}<br></span>
                                    {{ $t('footer.c21')}}<br>
                                    +380 95 466-99-12<br>
                                    igor.masechko@modern-expo.com<br>
                                </div>
                                <div class="col-md-3">
                                    <span>{{ $t('footer.c3')}}<br></span>
                                    {{ $t('footer.c31')}}<br>
                                    +380 50 437-37-41<br>
                                    olga.korniychuk@modern-expo.com<br>
                                </div>
                                <div class="col-md-3">
                                    <span>{{ $t('footer.c4')}}<br></span>                                  
                                    {{ $t('footer.c41')}}<br>
                                    +380 95 466-99-12<br>
                                    yurii.moklytsia@modern-expo.com<br>
                                </div>
                            </div>
                         </div>
                         
                     </div>
                 </div>
                
            </section>
        </main>
        
    </div>   

</div>
    
</template>
<script>
import { required, email  } from 'vuelidate/lib/validators'
import { VueRecaptcha } from 'vue-recaptcha';
import json from "../tenders.json";
import SidebarFront from '../components/menu/SidebarFront';
  export default {
    name: "frontPage",
    components: {   
      VueRecaptcha ,
      SidebarFront
        },
    data(){
      return{
          form:{
              firstName:"",
              familyName:"",
              email:"",
              phone:"",
              message:"",
              type:"0",
              notifyByPhone:true             
          },
          questionType:{
              0:"default",
              1:"transport",
              2:"services",
              3:"installation"
          },
          rKey:null,
          rcapchaError:false,
          content:null,
          section: 0,
          listOfTender:json.data,
          filterStr: "",
          pageNumber:0,
          size:10,
          paggSize:5,
          direction: 'asc',
          tender: {
          typeOfTansportationVal: null,          
          statuses:[
            {name: 'statuses.all', value: '', id: 0, checked: true, clientFilter:true, logistFilet:true},
             {name: "statuses.active", value: "active", id: 4, checked: false, clientFilter:false, logistFilet:true},
             {name: "statuses.inconfirm", value: "inconfirm", id: 2, checked: false, clientFilter:false, logistFilet:true},                                    
            {name: "statuses.closed", value: "closed", id: 3, checked: false, clientFilter:false, logistFilet:true},           
            {name: "statuses.vinnerset", value: "vinnerset", id: 5, checked: false, clientFilter:false, logistFilet:false},
            {name: "statuses.new", value: "new", id: 9, checked: false, clientFilter:true, logistFilet:false},
            {name: "statuses.takepart", value: "takepart", id: 8, checked: false, clientFilter:false, logistFilet:false},
            {name: 'statuses.confirmed',value: 'confirmed', id: 1, checked: false, clientFilter:false, logistFilet:true},
            {name: "statuses.ratecanseled", value: "ratecanseled", id: 6, checked: false, clientFilter:false, logistFilet:false},
            {name: "statuses.notintrast", value: "notintrast", id: 7, checked: false, clientFilter:false, logistFilet:false},
            {name: "statuses.lost", value: "lost", id: 10, checked: false, clientFilter:false, logistFilet:false},
            
            
          ],
          deliveryStatus:[
            //   {name:'delivery.all', value:'', id:0, checked:true},
              {name:'delivery.in', value:'', id:1, checked:false},
              {name:'delivery.out', value:'', id:2, checked:false},
            ],
            choosen:[
                {name: 'statuses.all', value: '', id: 0, checked: true},
            ]   
          },
      }
    },
    methods: {        
        getAllTender(){                        
            this.makeRequest("/service/getPublicListTender", {language:this.$i18n.locale}, true)
            .then(res => {
                if(res.data.result){ 
                    this.content = res.data.data.content
                    if (res.data.data.listTenders.length){                       
                        this.listOfTender = res.data.data.listTenders
                    }                 
                }
            });           
        },
        verifyRecaptcha(data){
            this.rKey = data;            
        },
        onCaptchaExpired () {
            // console.log("onCaptchaExpired");
            this.$refs.recaptcha.reset()
            this.rKey = null;
        },
        getCaptchaToken (){
         return  this.$refs.recaptcha.execute()
        },
        sendMessage(){
            this.$v.$touch()
            // this.getCaptchaToken()
            if (!this.rKey)  {
                this.rcapchaError = true
                return
            }         
            if (this.$v.$invalid || !this.rKey ) {
               console.log("error");
            }
            else {
            const newMessage = {
               firstName: this.form.firstName,
               familyName: this.form.familyName,
               email: this.form.email,
               phone: this.form.phone,
               message: this.form.message,
               type: this.questionType[this.form.type],
               notifyByPhone: this.form.notifyByPhone,
               token: this.rKey
            }
            console.log(this.rKey);
            this.makeQuery("/service/sendEmail", {message:newMessage}, true)
            .then(res => {
                console.log(res);
                if(res.data.result){ 
                    this.showNotification('custom-success','Success', res.data.data);
                    this.form.firstName = "";
                    this.form.familyName = "";
                    this.form.email = "";
                    this.form.phone = "";
                    this.form.message = "";
                    this.form.type = "0";
                    this.notifyByPhone = true;
                    this.$v.$reset()
                }
                else {
                    this.showNotification('custom-info','Error', res.data.data);
                }
            });
        }
        },
        scrollTo(element, container){     
        let options={
          container: container,
          easing: 'ease-in',
          offset: -60,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var VueScrollTo = require('vue-scrollto');
        let duration = 500
         VueScrollTo.scrollTo(element, duration, options)
    },
        
        filterBydeliveryClick(item){
            let active = _.find(this.tender.deliveryStatus,function(o) { return o.id == item.id; })
            active.checked = !active.checked;            
        },       

        filtrClick(item){
                //  this.tender.filterchoosen = [],
                // this.tender.statuses[index].checkeded = !this.tender.statuses[index].checkeded;
                // index != 0 ? this.tender.statuses[0].checkeded = false : this.tender.statuses[0].checkeded = true;

                // this.tender.filterchoosen.push(item.id)
                let arr = this.tender;                
                arr.choosen = [];
                let notall = false;
                item.checked = !item.checked;
                let bool = item.checked;

                let itemAll =  arr.statuses[0];

                if(item == itemAll){
                    for (let i = 0; i <  arr.statuses.length; i++){
                        if( arr.statuses[i] != item){ arr.statuses[i].checked = false;}
                    }
                } else {
                    if(itemAll.checked == true){
                        item.checked = true;
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if( arr.statuses[i] != item){
                                 arr.statuses[i].checked = false;
                            }
                            
                        }
                    } else {
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if(( arr.statuses[i].checked == false) && ( arr.statuses[i] != itemAll)){
                                notall = true;
                            }
                            
                        }

                        console.log(notall)
                        if(notall == true){
                            itemAll.checked = false;
                        } else {
                            itemAll.checked = true;
 
                            for (let i = 0; i <  arr.statuses.length; i++) {
                                if( arr.statuses[i] != itemAll){
                                     arr.statuses[i].checked = false;
                                }
                            }
                        }
                    }
                }

                //нажаті
                for (let i = 0; i <  arr.statuses.length; i++) {
                    if( arr.statuses[i].checked == true){
                        arr.choosen.push( arr.statuses[i]);
                    }
                }
                if(arr.choosen.length < 1){
                    arr.statuses[0].checked = true;
                    arr.choosen.push(arr.statuses[0]);
                }

                
            },
        
      sortData(key){
                if (this.sortKey == key){
                    this.boolDir = !this.boolDir;
                } else {
                    this.boolDir = false;
                }
                if (this.boolDir){
                    this.direction = 'asc';
                    this.classSort = 'icon-sort-amount-asc';
                } else {
                    this.direction = 'desc';
                    this.classSort = 'icon-sort-amount-desc';
                }

                this.sortKey = key;
            },
        
       startevent(){
           let self = this;
           console.log("start job")
           this.timerId = setInterval(work, 60000)
           function work(){
               self.getAllTender();
           } 
        //    _.debounce(work, 600)();          
         },
         setActive(e){ 
            //  console.log(e);
             let activeItemId             
             if (e.target.localName == "td"){activeItemId = e.target.parentElement.id;}
             else {activeItemId = e.target.parentElement.parentNode.id}
             this.goToRef(activeItemId);        
            if(this.activeRowClass) {this.unsetActive(this.activeRowClass)}
            e.currentTarget.className += " active";  
            this.activeRowClass = true;          
         },
         unsetActive(target){
             let elements = document.querySelectorAll('.active');
             if (elements){
                for (let elem of elements) {
                    elem.classList.remove('active');
                }
            }            
         }
    },  
     validations() {             
            return {
              form:{
                firstName:{
                    required
                },
                familyName:{
                    required                   
                },
                
                email:{
                    required,
                    email            
                },
                message:{
                    required                       
                },             
                type:{
                    required                       
                }              
                      
            },            
        }      
  },  
    computed:{
        getContentAbout(){
            if (this.content) {
               return this.content.filter((el,index) => index == "about") 
            }
            else return ""
        },
        getCaptchaClass(){
            return !this.rKey && !this.rcapchaError ? "cliar" : "rcapcha-error";
        },      
        userRole(){
            if(this.$store.getters.getUserRoleAdmin || this.$store.getters.getUserRoleLogist){
                return  "admin"    
            }
            else return "client"
           
        },      
        
        clientFilet(){
            return _.filter(this.tender.statuses, 'clientFilter' )
        },
       
      listFiltered: function(){
                let self = this;
                let find = this.filterStr.toLowerCase();
                let filterBystatus = this.tender.statuses;
                let found1 = true;
                let found2 = false;                
                this.pageNumber = 0;
                function filterByDelivery(item){
                    let checked = _.find(self.tender.deliveryStatus, function (o){return o.checked})
                    if(!checked) {return true}
                    else if(item.deliveryType == checked.id){return true}
                    else return false;
                }
               if (!_.isEmpty(this.listOfTender)){
                   return this.listOfTender.filter(item => {
                    found1 = false;
                    found2 = false;
                    if( (find == '') || ((item.id != null) && (item.id.toLowerCase().indexOf(find) > -1)) 
                    || ((item.number != null) && (item.number.toLowerCase().indexOf(find) > -1)) 
                    || ((item.typeTransport != null) && (item.typeTransport.toLowerCase().indexOf(find) > -1)) 
                    || ((item.typeOpetation != null) && (item.typeOpetation.toLowerCase().indexOf(find) > -1)) 
                    || ((item.responsible != null) && (item.responsible.toLowerCase().indexOf(find) > -1)) 
                    || (item.deliveryAdress && (item.deliveryAdress != null) && (item.deliveryAdress.toLowerCase().indexOf(find) > -1)) 
                    || (item.loadingAdress && (item.loadingAdress != null) && (item.loadingAdress.toLowerCase().indexOf(find) > -1)) ){
                        found1 = true;
                    }

                    for (let i = 0; i < this.tender.choosen.length; i++){
                        if( (this.tender.choosen[i].id == 0) || ((item.status != null) && (item.status == this.tender.choosen[i].id))){
                            found2 = true; 
                            break;
                        }
                    }

                    if(found1 && found2 && filterByDelivery(item)){
                        return item;
                    }
                })
                }
                else return {}
              
                
            },
            
            pageCount(){
                let l = this.listFiltered.length;
                let ss = this.size;                
                return Math.ceil(l/ss);
            },
            pages: function(){
                let arr = [];
                for (let i = 0; i < this.pageCount; i++) { 
                    arr[i] = i + 1;
                }
                let divider = Math.trunc(this.paggSize/2);
                let start = this.pageNumber - divider;
                let end = this.pageNumber + divider + 1;
                if (start < 0) {
                    start = 0;
                }
                let final_arr = arr.slice(start,end);
                if ((start + 1) > arr[0]){
                    final_arr.unshift('...');
                }
                if(end < arr[arr.length - 1]){
                    final_arr.push('...');
                }
                return final_arr;
            },
            paginatedData(){
                if (this.sortedData.length > 0){
                    const start = this.pageNumber * this.size,
                        end = start + this.size;
                    return this.sortedData.slice(start, end);
                }
            },
            sortedData: function () {
                return _.orderBy(this.listFiltered, this.sortKey, this.direction);
            },
    },
    created() {  
       
       

        
    },
    mounted(){       
        this.getAllTender();
        this.$root.$on('changeLanguage', request => this.getAllTender());        
        // this.startevent();
        // $(function () { $('[data-toggle="tooltip"]').tooltip() })
    },   
    beforeDestroy(){
        this.$root.$off()
        // console.log('stop timer' + this.timerId );
        // window.clearTimeout(this.timerId);
    }
  }
</script>

<style scoped>
html body {
     background-color: #fff;
}

.front-paga {
    font-family: -apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", "Helvetica Neue", Arial, sans-serif;
   
}
.title {
    background: #E5E5DB;
}
.title h1 {
    margin-bottom: 0;
    padding: 15px;
    font-weight: bold;
    text-transform: uppercase;
}
#logo {
    background: url(/dist/me_logo_dark.png) no-repeat;
    background-size: contain;
    min-width: 15rem;
    min-height: 1.8rem;
    max-width: 15rem;
    max-height: 1.8rem;
}
.body.vertical-layout.vertical-menu .navbar .navbar-header {
    background: #fff;
    
}
.header-navbar .navbar-container ul.nav li > a.nav-link {
    padding: 0.8rem 0.6rem;
    padding-bottom: 5px;
    text-transform: uppercase;
}
.register-link a{
    margin-top: 10px;
}
.register-link a:hover {
    background-color: #000;
    color: #fff;

}
.menu-link:hover {
    border-bottom: 5px solid #000;
}
.selected-language {
    padding: 5px 5px;
    border: 1px solid #000;
    display:inline !important;
}
.dropdown .dropdown-menu {
    min-width: 40px;
    background: #000;
    color: #fff;
}
.dropdown-item {
    color: #fff;
}
.dropdown-item:hover {
    color: #000;
}
a:not([href]):not([tabindex]):hover {
    color: #000;
}
.main-wraper {
    margin-top: 35px;
}
.tender-type-item {
    border-top: 2px solid #000;
}
.tender-type-link.collapsed {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 100px 25px 0;
    font-size: 28px;
    line-height: 32px;
    letter-spacing: -0.02em;
    color: #000;
    background-color: #fff;
    transition: padding .4s, background .4s;
    margin-bottom: 0px;
    padding-left: 10px;
}
.tender-type-link {
    color: #fff;
    background-color: #000;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 100px 25px 0;
    font-size: 28px;
    line-height: 32px;
    letter-spacing: -0.02em;    
    transition: padding .4s, background .4s;
    margin-bottom: 0px;
    padding-left: 10px;
}
.tender-type-link:hover {
    background: #000;
    color: #fff;
}
.tender-type-link:hover:not(.active) {
    padding-left: 35px;
    background: #000;
    color: #fff;
}
.tender-type-link.collapsed:before {
    content: '';
    position: absolute;
    top: 50%;
    margin-top: -12px;
    right: 3px;
    width: 24px;
    height: 24px;
    transition: 0.2s ease-in-out;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMDAwMSAzSDExLjAwMDFWMTFMMyAxMVYxM0gxMS4wMDAxVjIxSDEzLjAwMDFWMTNIMjFWMTFMMTMuMDAwMSAxMVYzWiIgZmlsbD0iYmxhY2siIC8+Cjwvc3ZnPg==);
}
.tender-type-link:before {
    content: '';
    position: absolute;
    top: 50%;
    margin-top: -12px;
    right: 3px;
    width: 24px;
    height: 24px;
    transition: 0.2s ease-in-out;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMDAwMSAzSDExLjAwMDFWMTFMMyAxMVYxM0gxMS4wMDAxVjIxSDEzLjAwMDFWMTNIMjFWMTFMMTMuMDAwMSAxMVYzWiIgZmlsbD0iYmxhY2siIC8+Cjwvc3ZnPg==);
}
.tender-type-link:hover:not(.active):before {
    right: 35px;
    color: #fff;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMDAwMSAzSDExLjAwMDFWMTFMMyAxMVYxM0gxMS4wMDAxVjIxSDEzLjAwMDFWMTNIMjFWMTFMMTMuMDAwMSAxMVYzWiIgZmlsbD0id2hpdGUiIC8+Cjwvc3ZnPg==);
}
.tender-type-link.active:before, .tender-type-link.active:before {
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMSAxMVYxM0wzIDEzTDMgMTFMMjEgMTFaIiBmaWxsPSJibGFjayIgLz4KPC9zdmc+);
}

.img-container {
    max-width: 550px;
   
}
.img-container img {
     box-shadow: 20px 20px #000;
     max-width: 650px;
}
.about-us .sub a{
    color: #8CD2E8;
    font-size: 36px;
}
.contacts {
    font-size: 14px;
    line-height: 24px;
}
.contacts span {
    display: block;
    margin-bottom: 10px;
    font-weight: bold;
  
}

.form label {
    font-size: 9px;
    color: #000;
}
.toogleLabel {
    font-size: 18px;
}

#type {
    width: 100%;
    padding: 7px 10px;
}
.social {
    padding-top: 12px;
}
@media (max-width: 767px) {
    .title {
        display: block !important;
    }
    .social {
        display: block !important;
        padding-bottom: 15px;
    }
}


.social-link img {
    width: 40px;
    height: 40px;
}
.send-mess-btn button{
    color: #000;
    border-color: #000;
    padding: 10px 40px;
}
.form-body input, .form-body textarea, .form-body select{
    border: 1px solid #000;
    border-radius: 0;
}
#type option{
 background-color: #000;
 color: #fff;
 margin-top: 20px;
}
.send-mess-btn button:hover{
    color: #fff;
    background-color:#000;
    border-color: #000;
}
.main-tables {
    font-size: 13px;
    border: 2px solid #000;
    background-color: #E5E5DB;
}
.main-tables thead{
    font-size: 15px;
    font-weight: bold;
}
.table-hover tbody tr {
    border-top: 2px solid #000;
}
.table-hover tbody tr:hover {
    background-color: #000;
    color: #fff;
}
.table-hover thead th {
    border-color: #000;
}
.page-item.active .page-link, 
.page-item.active .page-link:focus {
    background-color: #000;
    border-color: #000;
}

.page-link {
    color: #000;
    padding: 0.5rem 0.5rem;
    line-height: 1;
}
.form-group__message, .error {
    font-size: 0.75rem;
    line-height: 1;
    display: none;
    /* margin-left: 14px; */
    margin-top: 0.6875rem;
    margin-bottom: 0.9375rem; }
.form-group--alert,
  .form-group--error {
    animation-name: shakeError;
    animation-fill-mode: forwards;
    animation-duration: .6s;
    animation-timing-function: ease-in-out; }
  
    .form-group--success .form__label, .form-group--success .form__label--inline {
    color: #43AC6A; }
  
  .form-group--success .form-group__addon {
    color: white;
    border-color: #85d0a1;
    background: #85d0a1; }
  
  .form-group--success input,
  .form-group--success textarea,
  .form-group--success input:focus,
  .form-group--success input:hover {
    border-color: #85d0a1; }
  
  .form-group--success + .form-group__message, .form-group--success + .error {
    display: block;
    color: #73c893; }
  
  .form-group--error .form__label, .form-group--error .form__label--inline, .form-group--error .label{
    color: #f04124; 
    display: block;
    }
  
  .form-group--error .form-group__addon {
    color: white;
    border-color: #f79483;
    background: #f79483; }
  
  .form-group--error input,
  .form-group--error textarea,
  .form-group--error input:focus,
  .form-group--error input:hover {
    border-color: #f79483; }
  
  .form-group--error  .form-group__message, .form-group--error  .error  {
    display: block;
    color: #f57f6c; }
    .form-group--error label {    
    color: #f57f6c; }
  
  .form-group--alert .form__label, .form-group--alert .form__label--inline {
    color: #f08a24; }
  
  .form-group--alert .form-group__addon {
    color: white;
    border-color: #f7bd83;
    background: #f7bd83; }
  
  .form-group--alert input,
  .form-group--alert textarea,
  .form-group--alert input:focus,
  .form-group--alert input:hover {
    border-color: #f7bd83; }
  
  .form-group--alert + .form-group__message {
    display: block;
    color: #f5b06c; }

 .rcapcha {
     width:fit-content ;
     
 }
 .rcapcha-error {
    border: 1px solid #f04124;
 }

</style> 





// WEBPACK FOOTER //
// src/pages/Front.vue